import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__keep-element-scroll';
export class KeepElementScroll {
    static init($root = $('body')) {
        const $scrollElement = $root.find(ELEMENT_SELECTOR);
        if (!$scrollElement.length) {
            return;
        }
        this.addActiveClassOnSubRoutes($scrollElement);
        $scrollElement.each((index, element) => {
            const $element = $(element);
            const $activeElement = $element.find('.active');
            const elementName = $element.data('element-name');
            const parameterName = `scroll-position-${elementName}`;
            this.addActionBeforeUnload($element, parameterName);
            if (!$activeElement.length) {
                return;
            }
            let scrollPos = sessionStorage.getItem(parameterName) || '0';
            if (scrollPos) {
                element.scrollTo(0, parseInt(scrollPos));
            }
            $('.js__scroll-list-item').on('click', event => {
                const $element = $(event.currentTarget);
                $element.addClass('selected');
                $element.parent().parent().addClass('selected-parent');
            });
        });
    }
    static addActiveClassOnSubRoutes($scrollElement) {
        $scrollElement.each((index, element) => {
            const $element = $(element);
            $element.find('.item').each((index, item) => {
                const $item = $(item);
                const href = $item.attr('href');
                if (href && href !== '/door' && String(window.location.pathname) === href) {
                    $item.addClass('active');
                    return;
                }
            });
            if (!$element.find('.item.active').length) {
                $element.find('.item').each((index, item) => {
                    const $item = $(item);
                    const href = $item.attr('href');
                    if (href && href !== '/door' && String(window.location.pathname).startsWith(href)) {
                        $item.addClass('active');
                        return;
                    }
                });
            }
        });
    }
    static addActionBeforeUnload($element, parameterName) {
        addEventListener('beforeunload', event => {
            if ($('.sylius-admin-menu-search-input').val()) {
                const $selectedItem = $element.find('.sylius-admin-menu .selected');
                const $notSelectedItems = $element.find('.sylius-admin-menu .item:not(.selected):not(.selected-parent)');
                $notSelectedItems.each((index, element) => {
                    $(element).show();
                });
                const activeElementPosition = $selectedItem.position().top;
                $notSelectedItems.each((index, element) => {
                    $(element).hide();
                });
                sessionStorage.setItem(parameterName, String(activeElementPosition));
            }
            else {
                sessionStorage.setItem(parameterName, String($element.scrollTop()));
            }
        });
    }
}
